import { render } from "./PrintClientTicketModal.vue?vue&type=template&id=f6cee616&scoped=true&ts=true"
import script from "./PrintClientTicketModal.vue?vue&type=script&lang=ts"
export * from "./PrintClientTicketModal.vue?vue&type=script&lang=ts"

import "./PrintClientTicketModal.vue?vue&type=style&index=0&id=f6cee616&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6cee616"]])

export default __exports__